// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils'

interface SpinnerProps {
  size?:      'sm' | 'md' | 'lg'
  label?:     string
  className?: string
}

const sizes = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
}

export function Spinner({ size = 'md', label, className }: SpinnerProps) {
  return (
    <div className={cn('flex items-center gap-2', className)} role="status">
      <Loader2 className={cn('animate-spin text-sage-600', sizes[size])} aria-hidden />
      {label && <span className="text-sm text-ink-3">{label}</span>}
      <span className="sr-only">{label ?? 'Laden...'}</span>
    </div>
  )
}
